// 自家手牌的輸入啟動契約。
// 使用 pointerdown 立即選牌，避免 action bar 在 pointerup 事件內同步銷毀、
// 重建手牌後，下一次 release 因瀏覽器／觸控輸入時序而遺失。

export const HandTileActivationEvent = {
  PointerDown: 'pointerdown',
} as const;

export interface IHandTileActivationTarget {
  on(event: string, listener: () => void): unknown;
}

export const bindHandTileActivation = (
  target: IHandTileActivationTarget,
  onActivate: () => void
): void => {
  target.on(HandTileActivationEvent.PointerDown, onActivate);
};
